import { render, staticRenderFns } from "./Gtfs.vue?vue&type=template&id=a3c1087e&scoped=true&"
import script from "./Gtfs.vue?vue&type=script&lang=js&"
export * from "./Gtfs.vue?vue&type=script&lang=js&"
import style0 from "./Gtfs.vue?vue&type=style&index=0&id=a3c1087e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c1087e",
  null
  
)

export default component.exports